import {h, Fragment} from "preact"
import { useAppState } from '@nosto/preact';

import NoResults from './NoResults';
import Products from './Products';
import Toolbar from './Toolbar';
import Sidebar from './Sidebar';
import SidebarCustomized from './SidebarCustomized';

import BottomToolbar from './BottomToolbar';
import SelectedFilters from './SelectedFilters';
import Loader from './elements/Loader';
import { MoreButton } from './elements';
import { useEffect, useState } from 'preact/hooks';

export default function Category() {
  const {
    response: { products },
    loading,
  } = useAppState();
  const foundProducts = products && products.total > 0;
  const toggleButtonId = 'toggle-mobile-sidebar';

  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div
      class="ns-serp ns-d-flex ns-flex-column ns-flex-md-row ns-font-inherit ns-p-4 ns-my-0 ns-mx-auto"
      data-nosto-element="search"
    >
      {/* {(foundProducts || (loading && foundProducts)) && (
      )} */}
      <div
        class="ns-d-block ns-d-md-inline ns-w-100 ns-border-box ns-p-0 ns-pl-md-5"
        style={loading ? 'position: relative;' : ''}
      >
        {foundProducts ? (
          <>
            <Toolbar lableFor={toggleButtonId} />

            <SidebarCustomized
              isMobileView={isMobileView}
              toggleId={toggleButtonId}
            >
              <SelectedFilters />
            </SidebarCustomized>
            {isMobileView && <SelectedFilters />}
            <Products />
            {/* <BottomToolbar /> */}
            <MoreButton />
          </>
        ) : loading ? (
          <Loader />
        ) : (
          <NoResults />
        )}

        {/* To enable InfiniteScroll - comment above block and uncomment below.
                    Don't forget to import InfiniteScroll component. */}
        {/* {foundProducts ? (
                    <>
                        <SelectedFilters />
                        <Toolbar />
                        <InfiniteScroll>
                            <Products />
                        </InfiniteScroll>
                    </>
                ) : loading ? (
                    <Loader />
                ) : (
                    <NoResults />
                )} */}
      </div>
    </div>
  );
}
